export const mockRulesData = {
  id: 1,
  policyName: 'Org wide policy',
  rollingExpiryDays: 20,
  rules: {
    attendanceBasedRules: {
      lateArrivals: [
        {
          id: 1,
          thresholdMinMinutes: 5,
          thresholdMaxMinutes: 10,
          pointsAwarded: 1,
          appliesToDays: 'ALL_DAYS',
          shiftFilterMinHours: null,
          shiftFilterMaxHours: 4,
          displayOrder: 1,
        },
        {
          id: 2,
          thresholdMinMinutes: 10,
          thresholdMaxMinutes: 30,
          pointsAwarded: 2,
          appliesToDays: 'ALL_DAYS',
          shiftFilterMinHours: null,
          shiftFilterMaxHours: null,
          displayOrder: 2,
        },
        {
          id: 3,
          thresholdMinMinutes: 30,
          thresholdMaxMinutes: null,
          pointsAwarded: 3,
          appliesToDays: 'ALL_DAYS',
          shiftFilterMinHours: null,
          shiftFilterMaxHours: null,
          displayOrder: 3,
        },
      ],
      earlyDepartures: [
        {
          id: 1,
          thresholdMinMinutes: 5,
          thresholdMaxMinutes: 10,
          pointsAwarded: 1,
          appliesToDays: 'ALL_DAYS',
          shiftFilterMinHours: null,
          shiftFilterMaxHours: 4,
          displayOrder: 1,
        },
        {
          id: 2,
          thresholdMinMinutes: 10,
          thresholdMaxMinutes: 30,
          pointsAwarded: 2,
          appliesToDays: 'ALL_DAYS',
          shiftFilterMinHours: null,
          shiftFilterMaxHours: null,
          displayOrder: 2,
        },
        {
          id: 3,
          thresholdMinMinutes: 30,
          thresholdMaxMinutes: null,
          pointsAwarded: 3,
          appliesToDays: 'ALL_DAYS',
          shiftFilterMinHours: null,
          shiftFilterMaxHours: null,
          displayOrder: 3,
        },
      ],
      missedShifts: [
        {
          id: 5,
          infractionType: 'SINGLE_MISSED_SHIFT',
          pointsAwarded: 5,
          // shiftFilterMinHours: 4,
          // shiftFilterMaxHours: 12,
          displayOrder: 1,
        },
        {
          id: 6,
          infractionType: 'CONSECUTIVE_MISSED_SHIFT',
          pointsAwarded: 8,
          // shiftFilterMinHours: 6,
          // shiftFilterMaxHours: 10,
          displayOrder: 2,
        },
      ],
    },
    thresholdAndEscalations: {
      escalationRules: [
        {
          id: 1,
          pointsThreshold: 5,
          stakeholdersToNotify: ['MANAGER', 'EMPLOYEE'],
          escalationType: 'NO_ACTION',
          displayOrder: 1,
          disciplinaryNoteType: null,
          severity: null,
          reviewCycle: null,
        },
        {
          id: 2,
          pointsThreshold: 10,
          stakeholdersToNotify: ['MANAGER', 'EMPLOYEE', 'ADMIN'],
          escalationType: 'NO_ACTION',
          displayOrder: 2,
          disciplinaryNoteType: null,
          severity: null,
          reviewCycle: null,
        },
        {
          id: 3,
          pointsThreshold: 15,
          stakeholdersToNotify: ['ADMIN', 'MANAGER', 'EMPLOYEE'],
          escalationType: 'DISCIPLINARY_NOTE',
          displayOrder: 3,
          disciplinaryNoteType: 'Leave Violation',
          severity: 'High',
          reviewCycle: null,
        },
        {
          id: 4,
          pointsThreshold: 15,
          stakeholdersToNotify: ['ADMIN', 'MANAGER', 'EMPLOYEE'],
          escalationType: 'PIP_REVIEW',
          displayOrder: 4,
          reviewCycle: 'PIP Review 2024-25',
          disciplinaryNoteType: null,
          severity: null,
        },
      ],
    },
  },
};
